import { Pipe, PipeTransform } from '@angular/core'
import { FireAlarmClassification } from '@wm-front/client/graphql'

@Pipe({
  name: 'fireAlarmClassification',
  standalone: true,
})
export class FireAlarmClassificationPipe implements PipeTransform {
  /** Transform fire alarm classification type into localised string
   * @param { FireAlarmClassification }
   * @returns { string }
   */
  public transform(value: FireAlarmClassification): string {
    switch (value) {
      case FireAlarmClassification.Aov:
        return $localize`:Info Value | Value for the fire alarm classification Aov type @@fireAlarmClassificationPipeAovLabel:AOV`
      case FireAlarmClassification.Ieag:
        return $localize`:Info Value | Value for the fire alarm classification Ieag type @@fireAlarmClassificationPipeIeagLabel:IEAG`
      case FireAlarmClassification.L1:
        return $localize`:Info Value | Value for the fire alarm classification L1 type @@fireAlarmClassificationPipeL1Label:L1`
      case FireAlarmClassification.L2:
        return $localize`:Info Value | Value for the fire alarm classification L2 type @@fireAlarmClassificationPipeL2Label:L2`
      case FireAlarmClassification.M:
        return $localize`:Info Value | Value for the fire alarm classification M type @@fireAlarmClassificationPipeMLabel:M`
      case FireAlarmClassification.P1:
        return $localize`:Info Value | Value for the fire alarm classification P1 type @@fireAlarmClassificationPipeP1Label:P1`
      case FireAlarmClassification.P2:
        return $localize`:Info Value | Value for the fire alarm classification P2 type @@fireAlarmClassificationPipeP2Label:P2`
      case FireAlarmClassification.P3:
        return $localize`:Info Value | Value for the fire alarm classification P3 type @@fireAlarmClassificationPipeP3Label:P3`
      case FireAlarmClassification.P4:
        return $localize`:Info Value | Value for the fire alarm classification P4 type @@fireAlarmClassificationPipeP4Label:P4`
      case FireAlarmClassification.P5:
        return $localize`:Info Value | Value for the fire alarm classification P5 type @@fireAlarmClassificationPipeP5Label:P5`
      case FireAlarmClassification.SmokeExtractionCentral:
        return $localize`:Info Value | Value for the fire alarm classification smoke extraction central type @@fireAlarmClassificationPipeSmokeExtractionCentralLabel:Centrale désenfumage`
      case FireAlarmClassification.Type_1:
        return $localize`:Info Value | Value for the fire alarm classification type 1@@fireAlarmClassificationPipeType1Label:Type 1`
      case FireAlarmClassification.Type_2A:
        return $localize`:Info Value | Value for the fire alarm classification type 2A@@fireAlarmClassificationPipeType2ALabel:Type 2A`
      case FireAlarmClassification.Type_2B:
        return $localize`:Info Value | Value for the fire alarm classification type 2B@@fireAlarmClassificationPipeType2BLabel:Type 2B`
      case FireAlarmClassification.Type_3:
        return $localize`:Info Value | Value for the fire alarm classification type 3@@fireAlarmClassificationPipeType3Label:Type 3`
      case FireAlarmClassification.Type_4:
        return $localize`:Info Value | Value for the fire alarm classification type 4@@fireAlarmClassificationPipeType4Label:Type 4`
      default:
        return $localize`:Info Value | Value for the fire alarm classification type unavailable@@fireAlarmClassificationPipeTypeUnvailableLabel:Indisponible`
    }
  }
}
